import styled, { keyframes } from 'styled-components'
import { breakpoints } from '../../../../constants/breakpoints.constants'

const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: scale(0.97);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
`

export const SectionContainer = styled.section`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 48px 16px;
	background-color: #e8ecf1;
	position: relative;

	@media (min-width: ${breakpoints.MEDIUM_SCREEN}px) {
		padding: 64px 40px;
	}

	@media (min-width: ${breakpoints.LAPTOP}px) {
		padding: 80px 60px;
	}
`

export const SectionTitle = styled.h2`
	font-size: 4.6rem;
	font-weight: 600 !important;
	color: var(--title-color);
	text-align: center;
	margin-bottom: 30px;

	@media (min-width: ${breakpoints.MEDIUM_SCREEN}px) {
		margin-bottom: 40px;
	}
`

export const TabsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 8px;
	margin-bottom: 28px;
	width: 100%;
	max-width: 900px;

	@media (min-width: ${breakpoints.MEDIUM_SCREEN}px) {
		gap: 12px;
		margin-bottom: 36px;
		flex-wrap: nowrap;
	}
`

export const TabButton = styled.button`
	padding: 10px 16px;
	font-size: 12px;
	font-weight: 600;
	border: 2px solid ${({ active }) => (active ? 'var(--primary-color)' : '#ccc')};
	background-color: ${({ active }) => (active ? 'var(--primary-color)' : '#fff')};
	color: ${({ active }) => (active ? '#fff' : '#555')};
	box-shadow: ${({ active }) => (active ? '0 4px 15px rgba(0, 0, 0, 0.15)' : 'none')};
	border-radius: 30px;
	cursor: pointer;
	transition: all 0.3s ease;
	outline: none;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	white-space: nowrap;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;

	&:hover {
		border-color: var(--primary-color);
		color: ${({ active }) => (active ? '#fff' : 'var(--primary-color)')};
	}

	@media (min-width: ${breakpoints.MOBILE_M}px) {
		padding: 10px 20px;
		font-size: 13px;
	}

	@media (min-width: ${breakpoints.MEDIUM_SCREEN}px) {
		padding: 12px 28px;
		font-size: 14px;
		flex: 1 1 0;
	}

	@media (min-width: ${breakpoints.LAPTOP}px) {
		padding: 14px 32px;
		font-size: 15px;
	}
`

export const ImageContainer = styled.div`
	width: 100%;
	max-width: 960px;
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 180px;

	@media (min-width: ${breakpoints.MEDIUM_SCREEN}px) {
		min-height: 350px;
	}

	@media (min-width: ${breakpoints.LAPTOP}px) {
		min-height: 420px;
	}
`

export const ModalityImage = styled.img`
	width: 100%;
	max-width: 960px;
	height: auto;
	border-radius: 12px;
	object-fit: contain;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
	animation: ${fadeIn} 0.4s ease-out;
`
